import { render, staticRenderFns } from "./SystemSettings.vue?vue&type=template&id=6b755c58&scoped=true&"
import script from "./SystemSettings.vue?vue&type=script&lang=ts&"
export * from "./SystemSettings.vue?vue&type=script&lang=ts&"
import style0 from "./SystemSettings.vue?vue&type=style&index=0&id=6b755c58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b755c58",
  null
  
)

export default component.exports